<div class="explorer-layout">
  <!-- LEFT: Flat MatTree -->
  <div class="left-pane">


    <div class="file-tree-container"
         [style.width]="leftWidth"
         [style.height]="height"
         style="overflow-y:auto">

      <!-- ROOT HEADER DROP ZONE -->
      <div class="root-header"
           [class.drag-over]="rootDropOver"
           (dragenter)="onRootDragOver($event)"
           (dragover)="onRootDragOver($event)"
           (dragleave)="onRootDragLeave($event)"
           (drop)="onRootDrop($event)"
           (click)="openRootFilePicker()">

        <mat-icon class="root-icon">folder_open</mat-icon>

        <div class="root-text">
          <div class="root-title">{{ rootPath || 'Root' }}</div>
          <div class="root-sub">Drop files here or click to upload to {{rootPath}}</div>
        </div>

        <input type="file" #rootInput hidden multiple (change)="onRootFileInput($event)" />
      </div>

      <mat-tree [dataSource]="flatData"
                [levelAccessor]="levelAccessor"
                [trackBy]="trackByPath"
                class="file-tree">


        <!-- FILE leaf row -->
        <mat-tree-node *matTreeNodeDef="let node; when: isFlatFile" matTreeNodePadding [attr.data-level]="node.level">
          <div class="file-node-row node-row">
            <button mat-icon-button disabled class="indent-btn"></button>
            <mat-icon [ngClass]="getFileIconCfg(node).colorClass">
              {{ getFileIconCfg(node).icon }}
            </mat-icon>
            <button mat-button class="btn-bg-blue" (click)="onPreview(node)">{{ node.name }}</button>
            <button mat-icon-button (click)="onDeleteFile(node)"><mat-icon style="color:red">delete</mat-icon></button>
            <!--<button mat-icon-button matTooltip="Preview" (click)="onPreview(node)">
          <mat-icon>preview</mat-icon>
        </button>-->
          </div>
        </mat-tree-node>


        <!-- FOLDER expandable row -->
        <mat-tree-node *matTreeNodeDef="let node; when: isFlatFolder"
                       matTreeNodePadding
                       (expandedChange)="onFlatExpanded(node, $event)"
                       [class.folder-node-expanded]="node._expanded"
                       [attr.data-level]="node.level">

          <div class="node-row"
               (dragenter)="onFolderDragOver(node, $event)"
               (dragover)="onFolderDragOver(node, $event)"
               (dragleave)="onFolderDragLeave(node, $event)"
               (drop)="onFolderDrop(node, $event)"
               [class.drag-over]="node._dragOver">

            <button mat-icon-button matTreeNodeToggle (click)="$event.stopPropagation()">
              <mat-icon>{{ node._expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
            </button>

            <mat-icon [ngClass]="getFileIconCfg(node).colorClass" class="node-icon folder">{{node._expanded ? 'folder_open' : 'folder'}}</mat-icon>
            <span class="node-name">{{ node.name }}</span>
            <span class="spacer"></span>

            <mat-progress-spinner *ngIf="node._loading"
                                  class="small-spinner"
                                  mode="indeterminate" diameter="18">
            </mat-progress-spinner>
          </div>
        </mat-tree-node>

      </mat-tree>

    </div>
  </div>

  <!-- RIGHT: Preview -->
  @if (preview) {
  <div class="right-pane" [style.width]="rightWidth" [style.height]="height">
    <div class="preview-toolbar">
      <div class="title">
        <mat-icon>visibility</mat-icon>
        <span>{{ getPreviewTitle() }}</span>
      </div>
      <div class="actions">
        <button mat-icon-button class="btn-bg-green" title="Download File" (click)="onDownload()">
          <mat-icon>download</mat-icon>
        </button>
        <button mat-icon-button class="btn-bg-red" title="Close" (click)="closePreview()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="preview-content">
      <div class="loading" *ngIf="isLoadingPreview()">
        <mat-progress-spinner mode="indeterminate" diameter="28"></mat-progress-spinner>
        <span>Loading preview…</span>
      </div>

      <div class="error" *ngIf="hasErrorPreview()">
        <mat-icon>error</mat-icon>
        <span>{{ preview.error }}</span>
      </div>

      <object *ngIf="isPdfPreview()" [attr.data]="preview.safeUrl" type="application/pdf" class="pdf-object">
        <iframe [src]="preview.safeUrl" class="pdf-iframe"></iframe>
      </object>

      <img *ngIf="isImagePreview()" [src]="preview.url" class="image-preview" alt="Image preview" />

      <pre *ngIf="isTextPreview()" class="text-preview">{{ preview.text }}</pre>

      <iframe *ngIf="isOfficePreview()" [src]="preview.safeUrl" class="office-viewer" referrerpolicy="no-referrer"></iframe>

      <div class="fallback" *ngIf="isFallbackPreview()">
        <mat-icon>insert_drive_file</mat-icon>
        <div>
          <div>No inline preview for this file type.</div>
          <div>Use the <strong>Download</strong> button above.</div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
